<script>
import { defineComponent } from 'vue';
import { useMeta } from 'quasar';

const metaData = {
  // sets document title
  title: 'Windy City Wire - Register Account',
  // optional; sets final title as "Index Page - My Website", useful for multiple level meta
  titleTemplate: title => `${title}`,
}

export default defineComponent({
    name: 'register',
    setup() {
        useMeta(metaData);
    },
    data() {
        return {
            form: {
                name: "",
                email: "",
                company: "",
                title: "",
                address1: "",
                address2: "",
                city: "",
                state: "",
                zip: "",
                country: "",
                phone: "",
                fax: ""
            }
        }
    },
    methods: {
        register() {
            this.$store.dispatch('auth/register', this.form);
        },
        clearForm() {
            this.form = {};
            this.form.name = "";
            this.form.email = "";
            this.form.company = "";
            this.form.title = "";
            this.form.address1 = "";
            this.form.address2 = "";
            this.form.city = "";
            this.form.state = "";
            this.form.zip = "";
            this.form.country = "";
            this.form.phone = "";
            this.form.fax = "";
        }
    },
    computed: {
        isValid() {
            return this.form.name.length==0 || this.form.email.length==0 || this.form.company.length==0 || this.form.title.length==0 || this.form.address1.length==0 || this.form.city.length==0 || this.form.state.length==0 || this.form.zip.length==0 || this.form.country.length==0 || this.form.phone.length==0 ? false : true;
        }
    }
})
</script>

<template>
    <q-layout>
        <q-page-container>
            <q-page>
                <div class="WCWContainer">
                    <div class="bodyContainer q-mt-md">
                        <div class="row mb-3">
                            <div class="col-12">
                                <router-link :to="'/'">
                                    <img class="mb-4 imgFull" src="@/assets/images/wcwLogoBLACK.png" />
                                </router-link>
                                <h2 class="text-center">Register</h2>
                                <p class="registerText">To register, please complete the form below, and we will respond to you during business hours. If you are an active customer, you can expect a response within 5-10 minutes. New or non-active customers will be contacted by a sales representative to set up your account.</p>
                            </div>
                        </div>
                        <div class="row q-mt-lg">
                        <q-scroll-area style="height: 50vh; width: 100vw !important">
                            <div class="col">
                                <div class="registerFormInput">
                                    <span class="registerInputButton"><i class="fas fa-user"></i></span>
                                    <input type="text" placeholder="Name *" v-model.trim="form.name">
                                </div>
                                <div class="registerFormInput">
                                    <span class="registerInputButton"><i class="fas fa-envelope"></i></span>
                                    <input type="email" placeholder="Email *" v-model.trim="form.email">
                                </div>
                                <div class="registerFormInput">
                                    <span class="registerInputButton"> <i class="fas fa-building"></i></span>
                                    <input type="text" placeholder="Company *"  v-model="form.company">
                                </div>
                                <div class="registerFormInput">
                                    <span class="registerInputButton"> <i class="fas fa-building"></i></span>
                                    <input type="text" placeholder="Title *"  v-model="form.title">
                                </div>
                                <div class="registerFormInput">
                                    <span class="registerInputButton"> <i class="fas fa-map-marker-alt"></i></span>  
                                    <input type="text" placeholder="Address 1 *" v-model="form.address1">
                                </div>
                                <div class="registerFormInput">
                                    <span class="registerInputButton"><i class="fas fa-map-marker-alt"></i></span>
                                    <input type="text" placeholder="Address 2" v-model="form.address1">
                                </div>
                                <div class="registerFormInput">
                                    <span class="registerInputButton"><i class="fas fa-city"></i></span>
                                    <input type="text" placeholder="City *" v-model="form.city">
                                </div>
                                <div class="registerFormInput">
                                    <span class="registerInputButton"><i class="fas fa-city"></i></span>
                                    <input type="text" placeholder="State *" v-model="form.state">
                                </div>
                                <div class="registerFormInput">
                                    <span class="registerInputButton"> <i class="fas fa-building"></i></span>
                                    <input type="text" placeholder="Zip Code *" v-model="form.zip">
                                </div>
                                <div class="registerFormInput">
                                    <span class="registerInputButton"><i class="fas fa-building"></i></span>
                                    <input type="text" placeholder="Country *" v-model="form.country">
                                </div>
                                <div class="registerFormInput">
                                    <span class="registerInputButton"><i class="fas fa-phone"></i></span>
                                    <input type="text" placeholder="Phone *" v-model="form.phone">
                                </div>
                                <div class="registerFormInput">
                                    <span class="registerInputButton"><i class="fas fa-fax"></i></span>
                                    <input type="text" placeholder="Fax" v-model="form.fax">
                                </div>
                            </div>
                        </q-scroll-area>
                        </div>
                        <div class="row q-mt-md">
                            <div class="col-12 text-center">
                                <q-btn :ripple="{ color: 'cyan-7' }" padding="7px 30px 7px 30px" squared class="bgWCWYellow" label="Register" style="border: 1px solid #666" @click="register()" :disabled="!isValid"/>
                            </div>
                        </div>
                        <div class="row q-mt-md q-mb-lg">
                            <div class="col-12">
                                <p class="loginSignin mt-3">Already a user?<router-link :to="'/login'">Click here</router-link> to sign-in.</p>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-12 text-center q-mb-md">
                                <router-link class="registerTOS" :to="'/terms-of-service'">Terms of Service</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </q-page>
        </q-page-container>
    </q-layout>
</template>


<style scoped>
.registerInputButton {
  color: #aaa;
  position: absolute;
  padding: 12px 8px;
  left: 0;
}
</style>
